<template>
  <div @click="handleClick" class="TILE" :class="{ EXPANDED: isSelected}">
    <div class="d-flex fd-column text-left ITEM" >
      <img
          class="IMAGE"
          :src="image"
      />
      <div class="TEXT d-flex fd-column " :class="{ 'bd-b-depot' : isSelected}">
        <div class="m-x-1 d-flex jc-between">
          <div
              :class="[isSelected ? 'c-depot' : 'c-gray70']"
              class="text-bold"
          >{{occupation.name}}</div>
          <span class="text-sm" selenium="link">
            {{ numberOfServices }} services
            <template v-if="isSelected"><vk-icon class="p-l-1" name="chevronup"/></template>
            <template v-else><vk-icon class="p-l-1" name="chevrondown" unbounded/></template>
          </span>
        </div>
        <div class="EMPTY" :class="{ ARROW: isSelected}"></div>
      </div>
      <div  v-if="showContent" class="TRAY" >
        <span class="d-flex jc-end cur-pointer c-gray70"><vk-icon name="close"/></span>
        <span class="h3 c-gray70 text-center">
          {{ occupation.name }}
        </span>
        <span class="text-center c-gray70 p-b-3">
          {{ numberOfServices }} services you can offer Home Depot customers
        </span>
        <div class="TRAY-BODY">
          <div
              v-for="(service, index) in services"
              :key="index"
              class="SERVICE"
          >
            {{service}}
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'occupation-card',
  props: {
    occupation: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      showContent: false,
      isSelected: false,
    };
  },

  computed: {

    numberOfServices () {
      return this.occupation.services.length || 0;
    },
    services () {
      const serviceNames = this.occupation.services.map(service => service).sort();
      return serviceNames;
    },
    image () {
      const name = this.occupation.name.toLowerCase().replace(/[ ,/]/g, '-');
      return `${this.$runtimeConstants.SALESFORCE_ACCOUNT_REDIRECT_DOMAIN}/pro/resource/1603206245000/BecomeaPro_Landing_Assets/images/services/${name}.jpg`;
    },
  },
  watch: {
    currentIndex (val) {
      if (val !== this.index) {
        this.isSelected = false;
        this.showContent = false;
      }
    },
  },
  methods: {
    handleClick () {
      if (this.currentIndex === -1) {
        this.$emit('handle-click', this.index);
        this.isSelected = true;
        setTimeout(() => {
          this.showContent = true;
        }, 500);
      }
      if (this.currentIndex === this.index) {
        this.$emit('handle-click', this.index);
        this.showContent = false;
        setTimeout(() => {
          this.isSelected = false;
        }, 100);
      }
      if (this.currentIndex !== -1 && this.currentIndex !== this.index) {
        this.$emit('handle-click', this.index);
        setTimeout(() => {
          this.isSelected = true;
        }, 200);
        setTimeout(() => {
          this.showContent = true;
        }, 700);
      }
    },
  },
};

</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  $desktop:980px;
  $tablet:768px;
  $wide:1248px;

  .ITEM {
    max-width: 290px;
    max-height: 217px;
    text-align: left;
    margin-bottom: 24px;
  }
  .IMAGE {
    align-self: auto;
    max-width:100%;
    overflow: hidden;
    object-fit: cover;
  }
  .TEXT {
    height:37px;
    padding: $unit;
    box-shadow: 0 0 4px 0 $color-gray50;
  }
  .TRAY {
    display: flex;
    flex-direction: column;
    justify-self: center;
    position: absolute;
    width:100%;
    @include mobile-only() {
      max-width: 300px;
    }
    @include tablet() {
      max-width:752px;
    }
    @include desktop() {
      max-width:956px;
    }
    @include wide() {
      max-width:1216px;
    }
    height: 300px;
    margin-top: 235px;
    border-top: 2px solid $color-depot;
    border-bottom: 2px solid $color-depot;
    left: 0;
    right:0;
    padding: 20px 2% 30px 2%;
    margin-left: auto;
    margin-right: auto;
  }
  .TRAY-BODY {
    column-count: 4;
    overflow-y: auto;
    flex-flow: column ;
    word-break: break-word;
    @include tablet-only(){
      column-count: 3;
    }
    @include mobile-only(){
      column-count: 1;
    }
  }
  .SERVICE {
    padding: 0 $unit*1  ;
    flex: 0 0 33%;
    @include mobile-only(){
      flex: 0 0 100%;
    }
    @include tablet-only(){
      flex: 0 0 50%;
    }
  }
  .TILE {
    margin-bottom: 0px;
    transition: 0.6s margin-bottom ease-in-out
  }
  .TILE.EXPANDED {
    margin-bottom: 340px;
  }
  .EMPTY {
  z-index: -1000;
    transition: z-index 0.5s ease;
  }
  .ARROW {
    padding-top: 18px;
    width:20px;
    height: 20px;
    border: solid 1px $color-depot;
    border-bottom-color: transparent;
    border-right-color: transparent;
    position: relative;
    top: 18px;
    left: 170px;
    background-color: $color-gray20;
    z-index: 10;
    transform: rotate(45deg);
  }
  .CLOSE-ICON {
    cursor: pointer;
    display: flex;
    justify-content: right;
  }
</style>
